import { http } from "@/lib/http";
export function fetchMezzofySummary() {
  return http
    .get("/api/bdvoucher/getMezSummary")
    .then((res) => res.data?.data || {});
}
export function fetchVoucherConfig() {
  return http
    .get("/api/bdvoucher/voucher-config")
    .then((res) => res.data?.data || {});
}
export function uploadMezVouchers({ data, entity, value }) {
  return http
    .post("/api/bdvoucher/uploadMezVouchers", { data, entity, value })
    .then((res) => res.data);
}
export function viewAllVouchers() {
  return http.get("/api/bdvoucher/viewAll").then((res) => res.data?.data || {});
}
export function viewVouchersNext(pageToken, serialNo = "") {
  return http
    .get(
      `/api/bdvoucher/viewAll_next?pageToken=${pageToken}&serialNo=${serialNo}`,
    )
    .then((res) => res.data?.data || {});
}
export function fetchVoucherMessages() {
  return http.get("/api/messages/get_vouchers").then((res) => res.data);
}
export function fetchVoucherMessagesNext(pageToken) {
  return http
    .get(`/api/messages/get_vouchers_next?pageToken=${pageToken}`)
    .then((res) => res.data);
}
export function fetchVoucherMessageReadNames(id) {
  return http
    .post("/api/messages/get_names", { docId: id })
    .then((res) => res.data);
}
export function deleteVoucher(id) {
  return http.delete(`/api/bdvoucher/delete/${id}`).then((res) => res.data);
}
export function sendVoucher(payload) {
  return http
    .post("/api/bdvoucher/sendVoucher", payload)
    .then((res) => res.data);
}
export function exportVouchersUrl(params) {
  return `${
    import.meta.env.VITE_API_BASE_URL || ""
  }/api/bdvoucher/exportData?${new URLSearchParams(params).toString()}`;
}
